module.exports = __webpack_public_path__ + "4e501fdbab242a9e8dcc220566c82518.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ping-pong.png
// module id = 2581
// module chunks = 0